// Allegati jsonb dei documenti POS (ordini fornitore, DDT passivi, fatture
// passive): contratto unico BE↔FE della singola voce.
//
// Una voce è SEMPRE un riferimento a un file caricato dal sistema tramite lo
// Storage Provider (`key` con prefisso tenant/documento assegnato dal
// backend). Non esistono più voci "libere" (`filename` su disco locale o
// `url` esterno): lo schema è strict e le rifiuta.
import { z } from 'zod';

const UUID_RE = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

/** Chiave provider di un allegato: `pos/<area>/<tenant>/<documento>/<random>[.ext]`. */
export const posAttachmentKeyPattern = new RegExp(
  `^pos/[a-z-]+/${UUID_RE}/${UUID_RE}/[a-f0-9]{32}(?:\\.[a-z0-9]{1,9})?$`,
);

export const posAttachmentEntrySchema = z.object({
  /** Nome originale del file mostrato all'utente. */
  name: z.string().min(1).max(255),
  /** Chiave nello Storage Provider, assegnata dal backend all'upload. */
  key: z.string().regex(posAttachmentKeyPattern, 'Chiave allegato non valida'),
  /** Url di download autenticato (index-based), riallineato dal backend. */
  url: z.string().max(512).optional(),
  size: z.number().int().nonnegative().optional(),
  mime: z.string().max(255).optional(),
  uploaded_at: z.string().max(64).optional(),
  uploaded_by: z.string().max(128).nullable().optional(),
}).strict();
export type PosAttachmentEntry = z.infer<typeof posAttachmentEntrySchema>;

export const posAttachmentListSchema = z.array(posAttachmentEntrySchema);

/** Prefisso chiave provider degli allegati di un ordine fornitore. */
export function purchaseOrderAttachmentKeyPrefix(tenantId: string, orderId: string): string {
  return `pos/purchase-orders/${tenantId}/${orderId}/`;
}

/** True se la chiave appartiene (per prefisso) all'ordine del tenant. */
export function isPurchaseOrderAttachmentKey(key: string, tenantId: string, orderId: string): boolean {
  return posAttachmentKeyPattern.test(key) && key.startsWith(purchaseOrderAttachmentKeyPrefix(tenantId, orderId));
}
